import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ActivityComments from './ActivityComments/ActivityComments';
import ArticleCommentForm from './article-commnet-form/ArticleCommentForm';
import useStyles from './styles';
import { selectArticleComment, selectArticleComments } from '../../../store/modules/articleComments/selectors';
import { getArticleCommentListRequest } from '../../../store/modules/articleComments/actions';
import { getDefaultArticleCommentsParams } from './config';
import { LoadingFrame, StatusSelect } from '../../../components';
import { selectProject } from '../../../store/modules/projects/selectors';

const ActivityPage = () => {
  const classes = useStyles();
  const { data: project, loading: projectLoading } = useSelector(selectProject);
  const dispatch = useDispatch();
  const { id: projectId } = useParams<{id: string}>();
  const params = getDefaultArticleCommentsParams(projectId);
  const comment = useSelector(selectArticleComment);
  const comments = useSelector(selectArticleComments);

  /* eslint react-hooks/exhaustive-deps: 0 */
  useEffect(() => {
    if (!projectLoading) {
      dispatch(getArticleCommentListRequest(params));
    }
  }, [dispatch, project]);

  if (project === null || projectLoading || comment.loading || comments.loading) {
    return <LoadingFrame />;
  }
  return (
    <>
      <Grid className={classes.page}>
        {project?.permissions.can_edit && (
          <>
            <Grid item>
              <StatusSelect />
            </Grid>
            <Grid item>
              <ArticleCommentForm />
            </Grid>
          </>
        )}
        {!comment.loading && !comments.loading && <Grid item><ActivityComments /></Grid>}

      </Grid>
    </>
  );
};

export default ActivityPage;
